/* eslint-disable no-undef */
import React, { useState, useEffect } from "react";
import './Login.css'
import { loadAnimation } from "lottie-web";
import { defineElement } from 'lord-icon-element';
import InfoContext from "../../Context";
import axios from "axios";
import { Turnstile } from '@marsidev/react-turnstile'
import logo_payku from '../../img/logo_payku.png';
import { useNavigate } from 'react-router-dom';
import { Box, Button, Dialog, DialogActions, DialogContent, TextField } from '@mui/material';
import { useContext } from "react";
import Footer from "../Footer/Footer";
import { useLocation } from "react-router-dom"


function Login() {
    const [status, setStatus] = useState()
    const sampleLocation = useLocation();
    const ecommerce = (sampleLocation.pathname).replace(/\//g, ``);
    const userEmailUrl = sampleLocation.search.replace('?email=', '')
    const newEmail = decodeURIComponent(userEmailUrl)
    const { style, setStyle, setDataBank, setUserSession, userSession } = useContext(InfoContext);
    const [codeAccess, setCodeAccess] = useState('')
    const [codeError, setCodeError] = useState('')
    const [openModalSuccess, setopenModalSuccess] = useState(false);
    const [openModalFailedCaptcha, setopenModalfailedCaptcha] = useState(false);


    const navigate = useNavigate();
    const navigateActive = () => {
        navigate('/FormData');
    }

    const validateCodeAccess = (event) => {
        setCodeAccess(event.target.value)
        if (event.target.value.length === 0) {
            setCodeError('el campo no puede estar vacío')
        } else {
            setCodeError('')
        }
    }
    const buttonStyle = {
        color: `${style.buttonLetters}`,
        background: `${style.buttonColor}`,
    }

    const ResponseURL = window.location.href;
    var userUrl = ResponseURL.split('/');
    const userEcommerce = userUrl[userUrl.length - 2]

    useEffect(() => {
        (async () => {
            try {
                const response = await axios.post(process.env.REACT_APP_URL, {
                    "access_key": process.env.REACT_APP_TOKEN,
                    "action": "get",
                    "ecommerce": ecommerce
                });
                let dataStyle = { 'data': response.data }
                sessionStorage.setItem('dataStyle', JSON.stringify(dataStyle))
                setStyle(response.data);

            } catch (error) {
                console.log(error.message);
            }
        })();

    }, [setStyle]);

    useEffect(() => {
        const preURL = "https://storage.googleapis.com/storage-payku-prd/"
        let userInfo = { 'user': 0 };
        sessionStorage.setItem('userInfo', JSON.stringify(userInfo));
        setUserSession(userInfo)
        if (style.backgroundType === 'color') {
            document.body.style.backgroundColor = `${style.backgroundColor}`
        }
        if (style.backgroundType === 'fixed') {
            document.body.style.backgroundImage = `url('${preURL}${style.backgroundImg}')`;
            document.body.style.backgroundSize = "cover";

        }
        if (style.backgroundType === 'repeat') {
            document.body.style.backgroundImage = `url('${preURL}${style.backgroundImg}')`;

        }
        var x = window.matchMedia("(max-width: 420px)")
        if (!x.matches) {
            document.body.style.backgroundRepeat = 'no-repeat';
            document.body.style.backgroundPosition = "center center";
            document.body.style.backgroundSize = "cover";
            document.body.style.width = "100%";
            document.body.style.height = "100vh";
            document.body.style.position = "fixed";
            document.body.style.backgroundAttachment = 'fixed';

        }
    }, [style])
    const handle_submit = async () => {
        let userInfo = { 'user': 0 };
        const res = await axios.post(process.env.REACT_APP_URL, {
            "access_key": process.env.REACT_APP_TOKEN,
            "action": "login",
            "ecommerce": userEcommerce,
            "email": newEmail,
            "password": codeAccess
        });
        if (res.data.status === "success") {
            let dataBank = { 'dataBank': res.data }
            sessionStorage.setItem('dataBank', JSON.stringify(dataBank))
            setDataBank(res.data.bank)
            userInfo.user = 1
            console.log(userInfo.user)
            sessionStorage.setItem('userInfo', JSON.stringify(userInfo));
            setUserSession(userInfo)
            navigateActive()


        } else {
            setopenModalSuccess(true)
        }
    }
    const handleClose = () => {
        setopenModalSuccess(false);
        setEmail('')
        setCodeAccess('')
    };

    useEffect(() => {
        if (status === "error") {
            setopenModalfailedCaptcha(true)
        }
    }, [status]);

    const empty = codeAccess.length === 0
    const disabled = codeError.length !== 0 || status !== 'solved'

    defineElement(loadAnimation);

    return (
        <div className="container" >
            <div className="card-login">
                <div className="nav">
                    <img className="img-logo" src={logo_payku} alt="logo" />
                </div>
                <hr />
                <div className="title-login">
                    <p>Complete los siguientes datos</p>
                </div>
                <form className="form-login">
                    <div className="input-login">
                        <Box
                            sx={{
                                maxWidth: '100%',
                            }}
                        >
                            <TextField
                                fullWidth
                                id="standard-textarea"
                                label="Email de usuario"
                                placeholder="alguien@ejemplo.com"
                                variant="standard"
                                value={newEmail}
                                InputProps={{
                                    endAdornment: (
                                        <lord-icon
                                            src="https://cdn.lordicon.com/okmiidnt.json"
                                            trigger="hover"
                                            colors="primary:#4d39e9,secondary:#a39cf4"
                                            scale="70"
                                        ></lord-icon>
                                    ),
                                }}
                            />
                        </Box>

                    </div>
                    <div className="input-login">
                        <Box
                            sx={{
                                maxWidth: '100%',
                            }}
                        >
                            <TextField
                                fullWidth
                                id="standard-number"
                                required
                                label="Código de Acceso"
                                placeholder="******"
                                variant="standard"
                                value={codeAccess}
                                onChange={(event) => validateCodeAccess(event)}
                                inputProps={{ maxLength: 5 }}
                                InputProps={{
                                    endAdornment: (
                                        <lord-icon
                                            src="https://cdn.lordicon.com/jljgmcsp.json"
                                            trigger="morph"
                                            colors="primary:#121331,secondary:#c69cf4,tertiary:#6c16c7"
                                            scale="70"
                                        >
                                        </lord-icon>
                                    ),
                                }}
                            />
                        </Box>

                        <p className="errorStyle-login">{codeError}</p>
                    </div>
                    <div className="section-button-login">
                        <div className="slider-captcha">
                            <div id="captcha">
                                <Turnstile
                                    options={{ size: 'normal' }}
                                    siteKey={process.env.REACT_APP_TOKEN_CAPTCHA}
                                    onError={() => setStatus('error')}
                                    onExpire={() => setStatus('expired')}
                                    onSuccess={() => setStatus('solved')}
                                />
                            </div>
                        </div>
                        <div className="button">
                            <Button
                                onClick={handle_submit}
                                id="button"
                                disabled={disabled || empty}
                                style={buttonStyle}
                            >
                                Continuar
                            </Button>
                        </div>
                    </div>
                </form>
                <Footer />
            </div>

            <Dialog
                className="modalSucess"
                open={openModalSuccess}
            >
                <DialogContent>
                    <div className="modalMessage">
                        <lord-icon
                            src="https://cdn.lordicon.com/inrunzby.json"
                            trigger="hover"
                            colors="primary:#ffc738,secondary:#4f1091"
                            scale="80"
                        >
                        </lord-icon>
                    </div>
                    <div className="Success">
                        <h4>Uno de los datos ingresados es incorrecto, o su anulación ya fue procesada. Por favor, intente de nuevo</h4>
                    </div>
                    <DialogActions>
                        <Button onClick={handleClose}>Aceptar</Button>
                    </DialogActions>
                </DialogContent>
            </Dialog>
            <Dialog
                className="captchaError"
                open={openModalFailedCaptcha}
            >
                <DialogContent>
                    <div className="captchaIcon">
                        <lord-icon
                            src="https://cdn.lordicon.com/inrunzby.json"
                            trigger="hover"
                            colors="primary:#ffc738,secondary:#4f1091"
                            scale="80"
                        >
                        </lord-icon>
                    </div>
                    <div className="error">
                        <h2>Lo siento, no podemos procesar su solicitud.</h2>
                        <h4>Presione ACEPTAR para volver a intentar. </h4>
                    </div>
                    <DialogActions>
                        <Button onClick={() => window.location.reload(false)} >Aceptar</Button>
                    </DialogActions>
                </DialogContent>
            </Dialog>
        </div>


    )
}

export default Login